var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.0123H18.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.2994H18.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5.01733H23.4375C23.6861 5.01733 23.9246 5.11513 24.1004 5.2892C24.2762 5.46328 24.375 5.69937 24.375 5.94555V25.4381C24.375 25.6843 24.2762 25.9204 24.1004 26.0945C23.9246 26.2686 23.6861 26.3663 23.4375 26.3663H6.5625C6.31386 26.3663 6.0754 26.2686 5.89959 26.0945C5.72377 25.9204 5.625 25.6843 5.625 25.4381V5.94555C5.625 5.69937 5.72377 5.46328 5.89959 5.2892C6.0754 5.11513 6.31386 5.01733 6.5625 5.01733H11.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 8.7302V7.80198C10.3125 6.57108 10.8064 5.39061 11.6854 4.52023C12.5645 3.64986 13.7568 3.16089 15 3.16089C16.2432 3.16089 17.4355 3.64986 18.3146 4.52023C19.1936 5.39061 19.6875 6.57108 19.6875 7.80198V8.7302H10.3125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/ClipboardText.788f8e6dfeaa88b13d9439638583a9e7.svg";
export { ForwardRef as ReactComponent };